import { render, staticRenderFns } from "./add-task.vue?vue&type=template&id=f53150a2&scoped=true&"
import script from "./add-task.vue?vue&type=script&lang=js&"
export * from "./add-task.vue?vue&type=script&lang=js&"
import style0 from "./add-task.vue?vue&type=style&index=0&id=f53150a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f53150a2",
  null
  
)

export default component.exports